import { data } from '../../svg/EditDocument/data';
import { makeIcon } from '../makeIcon';

export const EditDocument = makeIcon(data, 'edit_document', 'EditDocument');

export default EditDocument;
